document.addEventListener('DOMContentLoaded', function () {
  initSpotlights();
  initHeadingReveal();
});

function initSpotlights() {
  if (window.matchMedia('(hover: none)').matches) return;

  document.querySelectorAll('.kv-hero-spotlight').forEach(function (spotlight) {
    var container = spotlight.closest('.slideshow__slide');
    if (!container) return;

    container.addEventListener('mousemove', function (event) {
      var rect = container.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      spotlight.style.setProperty('--kv-spotlight-x', x + '%');
      spotlight.style.setProperty('--kv-spotlight-y', y + '%');
      spotlight.classList.add('kv-hero-spotlight--active');
    });

    container.addEventListener('mouseleave', function () {
      spotlight.classList.remove('kv-hero-spotlight--active');
    });
  });
}

function initHeadingReveal() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.kv-hero-heading-reveal').forEach(function (heading) {
    if (reduceMotion || heading.children.length > 0) return;

    var words = heading.textContent.trim().split(/\s+/);
    heading.textContent = '';
    heading.classList.add('kv-hero-heading-reveal--ready');

    words.forEach(function (word, index) {
      var span = document.createElement('span');
      span.className = 'kv-hero-word';
      span.style.transitionDelay = index * 0.07 + 's';
      span.textContent = word;
      heading.appendChild(span);
      heading.appendChild(document.createTextNode(' '));
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        heading.classList.add('kv-hero-heading-reveal--visible');
      });
    });
  });
}
